import React from 'react';
import {useParams} from 'react-router-dom';

const OtherPage = () => {
    const pageId = useParams().pageId;

    return (
        <div>
            <h2>OtherPage 2: {pageId}</h2>
        </div>
    );
}

export default OtherPage;

